export default {
  /**
   * @type{AwardsResult}
   */
  // awardsResult: null,

  awardsData: null,

  filterEngine: null,
  
  filterVersion: 0,

  selectedFilters: [],

  /**
   * @type{LeaderboardResult}
   */
  leaderboardResult: null,

  isFiltersPanelDataLoaded: false,

  cadreRankingsData: null,
};
